import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


// Vue resource is install for getting data from firebase
import VueResource from "vue-resource";
Vue.use(VueResource);
Vue.http.options.root = 'https://commaful-e1381.firebaseio.com'
Vue.http.headers.common['Authorization'] = 'Basic YXBpOnBhc3N3b3Jk'


export const EventBus = new Vue();
// reset/normalize css
import './assets/css/normalize.css';
// Import style css
import './assets/css/style.css';



// Vue page trasition
import VuePageTransition from 'vue-page-transition';
Vue.use(VuePageTransition);

// Vue tour
import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);


// Import moment js for date time
import moment from 'moment';
Vue.filter('dateFormat', function (creted) {
  return moment(creted).format('ddd, DD MMM YY, h:mm a');
})

// prety button css
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton)

//global component vai plugin
import CommafulDashboard from './plugins/commaful-global';
Vue.use(CommafulDashboard);


//vue text area
import VueTextareaAutosize from "vue-textarea-autosize";
Vue.use(VueTextareaAutosize);

//vue progress bar
import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
  color: 'rgb(0, 198, 198)',
  failedColor: 'red',
  height: '2px'
})

// Vue sweet alert
import VueNoty from 'vuejs-noty';
Vue.use(VueNoty);
import 'vuejs-noty/dist/vuejs-noty.css';


// Sticky area globally
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)


Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");




Vue.filter('shortDes', function (value) {
    if (!value){
        return ''
    }
    if(value.length < 20) {
    	return value;
    } 
    return value.substring(0,20)+"..."
})
